<ng-container *ngIf="product$ | async as product">
  <div
    class="pdp-price"
    [ngClass]="[activeLanguage$ | async, activeCountry$ | async]"
    [class.srp-toggle-on]="showSrp"
    *ngIf="gstInclusive !== null && gstExclusive !== null && tooltipIconConfig !== null"
  >
    <div class="srp-price">
      <div class="price-label-info">
        <span class="pdp-price-label" [ngClass]="activeLanguage$ | async">{{
          'product.productList.srp' | cxTranslate
        }}</span>
        <app-tooltip-icon
          *ngIf="tooltipIconConfig?.enabled"
          [matIconName]="tooltipIconConfig?.matIconName"
          [matIconTheme]="tooltipIconConfig?.matIconTheme"
          [placement]="float ? 'bottom-right' : 'top-right'"
          [size]="tooltipIconConfig?.size"
          [tooltipContent]="'tooltip.srp' | cxTranslate"
          [closeOnScroll]="tooltipIconConfig?.closeOnScroll"
        ></app-tooltip-icon>
      </div>
      <span class="pdp-price-value">{{ product?.srpPrice?.formattedValue }}</span>
      <span class="gst-label" *ngIf="product?.srpPrice?.formattedValue && gstInclusive">{{
        'gst.inclusive' | cxTranslate
      }}</span>
    </div>
    <div class="base-price" *ngIf="!showSrp && !basepriceHidden">
      <div class="price-label-info">
        <span class="pdp-price-label">{{ 'product.productList.basePrice' | cxTranslate }}</span>
        <app-tooltip-icon
          *ngIf="tooltipIconConfig?.enabled"
          [matIconName]="tooltipIconConfig?.matIconName"
          [matIconTheme]="tooltipIconConfig?.matIconTheme"
          [placement]="float ? 'bottom-right' : 'top-right'"
          [size]="tooltipIconConfig?.size"
          [tooltipContent]="'tooltip.basePrice' | cxTranslate"
          [closeOnScroll]="tooltipIconConfig?.closeOnScroll"
        ></app-tooltip-icon>
      </div>
      <span class="pdp-price-value">{{ product?.basePrice?.formattedValue }}</span>
      <span class="gst-label" *ngIf="product?.basePrice?.formattedValue && gstExclusive">{{
        'gst.exclusive' | cxTranslate
      }}</span>
    </div>
    <div class="dealer-price" *ngIf="!showSrp">
      <div class="price-label-info">
        <span class="pdp-price-label">{{ 'product.productList.dealerPrice' | cxTranslate }}</span>
        <app-tooltip-icon
          *ngIf="tooltipIconConfig?.enabled"
          [matIconName]="tooltipIconConfig?.matIconName"
          [matIconTheme]="tooltipIconConfig?.matIconTheme"
          [placement]="float ? 'bottom-right' : 'top-right'"
          [size]="tooltipIconConfig?.size"
          [tooltipContent]="
            (dealerPrice(product.code) ? 'tooltip.hasDealerPrice' : 'tooltip.hasNoDealerPrice') | cxTranslate
          "
          [closeOnScroll]="tooltipIconConfig?.closeOnScroll"
        ></app-tooltip-icon>
      </div>
      <div class="spinner-shimano-wrapper-dp" *ngIf="!dealerPrice(product.code); else dealerPriceReady">
        <div class="spinner-shimano" *ngIf="this.hasDealerPrice">
          {{ setDisabled() }}
          <div></div>
        </div>
        <div class="no-dealer-price no-dealer-price-pdp" *ngIf="!this.hasDealerPrice"></div>
      </div>
      <ng-template #dealerPriceReady>
        {{ setEnabled() }}
        <ng-container *ngIf="erpPromotions$ | async as erpproduct; else displayDealerPrice">
          <ng-container
            *ngIf="
              erpproduct.dealerPrices.length > 0 &&
                erpproduct.dealerPrices[0].promotionMessage &&
                erpproduct.dealerPrices[0].promotionMessage !== '';
              else displayDealerPrice
            "
          >
            <span class="pdp-price-value erp-promo">{{ dealerPrice(product.code) }}</span>
            <span class="gst-label" *ngIf="dealerPrice(product.code) && gstExclusive">{{
              'gst.exclusive' | cxTranslate
            }}</span>
            <span>{{ erpproduct.dealerPrices[0].promotionMessage }}</span>
          </ng-container>
        </ng-container>

        <ng-template #displayDealerPrice>
          <span class="pdp-price-value">{{ dealerPrice(product.code) }}</span>
          <span class="gst-label" *ngIf="dealerPrice(product.code) && gstExclusive">{{
            'gst.exclusive' | cxTranslate
          }}</span>
        </ng-template>
      </ng-template>
    </div>
  </div>
</ng-container>
